const routerBase = 'platform/zz-platform-pages'

const VARS = {
  // 渠道号
  channel: '',
  // 编码
  t: '',
  // lego统计点前缀
  legoPrefix: 'h5plpages_',
  // zzusercenter路径
  zzUserCenter: window.location.protocol + '//app.zhuanzhuan.com/zz/v2/zzusercenter',
  // b2c秒杀活动接口路径
  zzYPactivity: window.location.protocol + '//app.zhuanzhuan.com/zzopen/pt_activity',
  // zzplatformActivity路径
  zzPlatformActivity: window.location.protocol + '//app.zhuanzhuan.com/zzopen/platform_activity',
  // zzinfologic路径
  zzInfoLogicPath: window.location.protocol + '//app.zhuanzhuan.com/zz/v2/zzinfologic',
  // zzinfoshow路径
  zzInfoShowPath: window.location.protocol + '//app.zhuanzhuan.com/zz/v2/zzinfoshow',
  // zzlogic路径
  zzLogicPath: window.location.protocol + '//app.zhuanzhuan.com/zz/v2/zzlogic',
  // transfer路径
  zzTransferPath: window.location.protocol + '//app.zhuanzhuan.com/zz/transfer',
  // zzburning
  zzBurning: window.location.protocol + '//app.zhuanzhuan.com/zzopen/zzburning',
  // 社区
  zzCommunity: window.location.protocol + '//app.zhuanzhuan.com/zzopen/zzcommunitylogic',
  // 图书
  zzSellBook: window.location.protocol + '//app.zhuanzhuan.com/zzopen/sellbook',
  // 发布
  zzPost: window.location.protocol + '//app.zhuanzhuan.com/zz/v2/zzpost',
  // apollo路径
  feConfPath: window.location.protocol + '//feconf.zhuanzhuan.com/feconf',
  // 是否是iphoneX
  isIphoneX: /iphone/gi.test(navigator.userAgent) && screen.height >= 812,
  // 是否是ios
  isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  isAndroid: navigator.userAgent.match(/Android.+ZhuanZhuan/i),
  // 是否是作为小程序 webview页面
  isWXWebviewFn: () => {
    // tslint:disable-next-line: no-string-literal
    return (
      window['__wxjs_environment'] === 'miniprogram' || /miniProgram/i.test(navigator.userAgent)
    )
  },
  // 微信环境
  isWx: /MicroMessenger/i.test(navigator.userAgent),
  // 字符转义
  arrEntities: {
    lt: '<',
    gt: '>',
    nbsp: ' ',
    amp: '&',
    quot: '"',
    hellip: '...',
    mdash: '——',
    middot: '.',
    lsquo: '‘',
    rsquo: '’',
    ldquo: '“',
    rdquo: '”',
    yen: '￥'
  },
  // 默认本地存储参数，用来存储各种标志位
  defLocalStorageName: 'zz_plpages_local_param',
  // 默认头像
  defaultFace: '//pic1.zhuanstatic.com/zhuanzh/n_v23c412979398041808ba09f2c894034a0.png',
  // 默认商品图
  defaultImg: '//pic2.zhuanstatic.com/zhuanzh/n_v2c64ea5899759433ca0f339cdcd6af8b5.png',
  // PIC url prefix
  picDomain: '//pic3.zhuanstatic.com/zhuanzh/',
  // 基础路由
  routerBase,
  // 基础路径
  basePath: `${location.protocol}//${location.host}/${routerBase}`
  // 人工客服地址
  // artificialServiceOnlineUrl: 'https://feentry.zhuanzhuan.com/kfzx_x?clientid=hls_x'
}
export default VARS
